<template>
    <div>
        <div class="search-box">
            <p>系别：</p>
            <a-select 
                class="input-box" 
                allowClear 
                show-search 
                :filter-option="filterOption"
                 v-model="searchFrom.departmentCode">
                <a-select-option v-for="(item,index) in xbArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
            <p>学年：</p>
            <a-select class="input-box" allowClear v-model="searchFrom.schoolYearCode">
                <a-select-option v-for="(item,index) in xnArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
            <p>教师名：</p>
            <a-input class="input-box" v-model="searchFrom.teacherName" />
            <a-button type="primary" icon="search" @click="searchList">搜索</a-button>
            <a-button type="primary" icon="download" class="right-btn" >导出Excel</a-button>
            <a-button type="primary" icon="plus" class="right-btn" @click="$refs.info.showDrawer('新增','')">新增</a-button>
        </div>
        <a-table 
            :columns="columns" 
            :data-source="data" 
            :loading="loading"
            :pagination="pagination"
            @change="handleTableChange"
            bordered>
            <template slot="departmentCode" slot-scope="text,record">
                <a-select class="show-input" v-model="record.departmentCode" disabled>
                    <a-select-option v-for="(item,index) in xbArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                </a-select>
            </template>
            <template slot="paperTypeCode" slot-scope="text,record">
                <a-select class="show-input" v-model="record.paperTypeCode" disabled>
                    <a-select-option v-for="(item,index) in lwlbArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                </a-select>
            </template>
            <template slot="schoolYearCode" slot-scope="text,record">
                <a-select class="show-input" v-model="record.schoolYearCode" disabled>
                    <a-select-option v-for="(item,index) in xnArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                </a-select>
            </template>
            <template slot="id" slot-scope="text">
                <a class="action-btn" @click="$refs.info.showDrawer('查看',text)">详情</a>
                <a-divider type="vertical" />
                <a class="action-btn" @click="$refs.info.showDrawer('编辑',text)">编辑</a>
                <a-divider type="vertical" />
                <a-popconfirm
                    title="确定删除？"
                    ok-text="确定"
                    cancel-text="取消"
                    @confirm="remove(text)"
                >
                    <a class="action-btn">删除</a>
                </a-popconfirm>
            </template>
        </a-table>
        <info ref="info"></info>
    </div>
</template>
<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { list,del } from '@/baseAPI/undergraduate/culture/guidancePaper'
    import Info from '../culture/modules/guidancePaperInfo'
    const columns = [
        {
            title: '序号',
            dataIndex: 'id',
            align:'center',
            width:70,
            customRender: (text, row, index) => {
                return { children: index+1};
            },
        },
        {
            title: '系别',
            dataIndex: 'departmentCode',
            align:'center',
            scopedSlots: { customRender: 'departmentCode' }
        },
        {
            title: '教师名',
            dataIndex: 'teacherName',
            align:'center'
        },
        {
            title: '类别',
            dataIndex: 'paperTypeCode',
            align:'center',
            scopedSlots: { customRender: 'paperTypeCode' }
        },
        {
            title: '人数',
            dataIndex: 'personNumber',
            align:'center'
        },
        {
            title: '核定分值',
            dataIndex: 'approvedScore',
            align:'center'
        },
        {
            title: '学年',
            dataIndex: 'schoolYearCode',
            align:'center',
            scopedSlots: { customRender: 'schoolYearCode' }
        },
        {
            title: '备注',
            dataIndex: 'remark',
            align:'center'
        },
        {
            title: '操作',
            dataIndex: 'id',
            scopedSlots: { customRender: 'id' }
        }

    ];
    export default {
        name: 'teacher',
        components: {
            Info
        },
        data () {
            return {
                columns,
                data:[],
                loading: false,
                pagination:{
                    pageSize: 10,
                    current: 0,
                    total:0,
                },
                searchFrom:{
                    size: '',
                    current: '',
                    departmentCode:'',
                    schoolYearCode:'',
                    teacherName:'',
                },
                xbArr:[],
                xnArr:[],
                lwlbArr:[],
            }
        },
        mounted () {
            getDicts({dataCode:'XY',status:true}).then(res=>{
                this.xbArr=res.data.dicts;
            })
            getDicts({dataCode:'XN',status:true}).then(res=>{
                this.xnArr=res.data.dicts;
            })
            getDicts({dataCode:'LWLB',status:true}).then(res=>{
                this.lwlbArr=res.data.dicts;
            })
            this.fetch()
        },
        methods:{
            handleTableChange(pagination){
                const pager = { ...this.pagination };
                pager.current = pagination.current;
                this.pagination = pager;
                this.fetch();
            },
            fetch() {
                this.loading = true;
                this.searchFrom.size=this.pagination.pageSize;
                this.searchFrom.current=this.pagination.current;
                list(this.searchFrom).then(res=>{
                    this.pagination.total = res.data.total;
                    this.data = res.data.records;
                    this.loading = false;
                })
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            searchList(){
                this.pagination.current=1;
                this.fetch()
            },
            remove(id){
                del(id).then(res=>{
                    if(res.data.success){
                        this.$notification['success']({
                            message: '成功',
                            description:'删除课程建设项目成功',
                        });
                        this.fetch()
                    }else{
                        this.$notification['error']({
                            message: '失败',
                            description:res.data.errorMessage,
                        });
                    }
                })
            },

        }
    }
</script>
<style scoped>
    .search-box
    {
        padding-bottom: 24px;
        border-bottom: 1px solid rgba(151,151,151,0.60);
        margin-bottom: 24px;
    }
    .search-box p
    {
        display: inline-block;
    }
    .search-box .right-btn
    {
        float: right;
        margin-left: 1rem;
    }
    .search-box .input-box{
        margin-right: 1rem;
        width: 13rem;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 14px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .table-tips{
        margin-top: -48px;
        line-height: 32px;
        padding-left: 15px;
        color: #aaa;
    }
    .ant-table-wrapper .show-input{
        height: 23px;
        line-height: 23px;
    }
    .ant-table-wrapper .show-input >>> .ant-select-selection{
        background-color: transparent;
        border: none;
        color: rgba(0, 0, 0, 0.65);
    }
    .ant-table-wrapper .show-input >>> .ant-select-arrow{
        display: none;
    }

</style>
